module.exports = __webpack_public_path__ + "img/18_109.76fc7023.png";